import { createAsyncThunk } from '@reduxjs/toolkit'
import { GetAllCarriers } from '@services/api/carrier.api'
import { CarrierList, UpdateCarrierThunkParams } from '@dataTypes/index'

export const fetchAllCarriers = createAsyncThunk(
  'api/insurances/fetchAllInsuranceProviders',
  async () => {
    try {
      const response = await GetAllCarriers()

      if (response.statusCode !== 200) {
        return response.message
      }

      if (response.data) {
        return response.data.insuranceProviders
      }

      return 'Carriers not found'
    } catch (error: any) {
      return error.message || 'An error occurred'
    }
  },
)

export const addCarrier = createAsyncThunk(
  'carriers/addCarrier',
  async (body: CarrierList) => {
    return body
  },
)

export const updateCarrier = createAsyncThunk(
  'carriers/updateCarrier',
  async (params: UpdateCarrierThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeCarrier = createAsyncThunk(
  'carriers/removeCarrier',
  async (index: string) => {
    return index
  },
)
